import Icon from '@/components/Icon'
import classNames from 'classnames/bind'
import React, { ChangeEventHandler } from 'react'
import * as styles from './style'
const cx = classNames.bind(styles)

export interface Props {
  value: string
  name: string
  label: string | React.ReactNode | React.ReactNode[]
  onChange?: ChangeEventHandler<HTMLInputElement>
  defaultChecked?: boolean
  reverse?: boolean
  reverseEffect?: boolean // Added flag to handle the checkboxes needs to have tick when unchecked and vise versa
  flush?: 'left' | 'right' | 'none'
  className?: string
  disabled?: boolean
}

const Checkbox = ({
  value,
  name,
  label,
  onChange,
  defaultChecked = false,
  reverse = true,
  reverseEffect = false,
  flush = 'none',
  className = '',
  disabled = false,
}: Props): JSX.Element => {
  const classes = cx({
    root: !reverseEffect,
    reverseEffect,
    reverse,
    [styles[`flush_${flush}`]]: true,
    [className]: true,
    'gsu-label': true,
  })
  return (
    <label htmlFor={name} className={classes}>
      <input
        type="checkbox"
        defaultChecked={defaultChecked}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        role="checkbox"
        disabled={disabled}
      />
      <span className={styles.checkbox}>
        <Icon name="tick-small" size={12} />
      </span>
      <span className={styles.labelText}>{label}</span>
    </label>
  )
}
export default Checkbox
